/* eslint-disable */
import { hiprint } from "@/print.js";
// 自定义设计元素1
const aProvider = function (ops) {
  // console.log(ops,'opsoppoo')
  var addElementTypes = function (context) {
    window.surperops = ops;
    context.removePrintElementTypes("aProviderModule");
    context.addPrintElementTypes(
      "aProviderModule",
      [
        new hiprint.PrintElementTypeGroup("平台", [
          {
            tid: 'aProviderModule.barcode',
            text: "条形码",
            data: '',
            type: 'text',
            options: {
              fields: ops.fieldsobj,
              testData: 'XS888888888',
              height: 32,
              fontSize: 12,
              lineHeight: 18,
              fontWeight: "700",
              textAlign: "center",
              textContentVerticalAlign: "middle",
              textType: "barcode"
            }
          },
          {
            tid: 'aProviderModule.qrcode',
            text: '二维码',
            data: '',
            type: 'text',
            options: {
              fields: ops.fieldsobj,
              testData: 'https://www.baidu.com/',
              width: 50,
              height: 50,
              fontSize: 12,
              lineHeight: 18,
              fontWeight: "700",
              textAlign: "center",
              textContentVerticalAlign: "middle",
              textType: "qrcode"
            }
          },
          {
            tid: 'aProviderModule.logo',
            text: '图片',
            data: '',
            options: {
              fields: ops.fieldsobj,
            },
            type: 'image'
          },
          {
            tid: 'aProviderModule.customText',
            text: "文本",
            customText: '',
            custom: true,
            options: {
              fields: ops.fieldsobj,
              width: 100,
              height: 14,
              fontSize: 12
            },
            type: 'text'
          },
          {
            tid: 'aProviderModule.longText',
            type: 'longText',
            text: "长文本",
            options: {
              fields: ops.fieldsobj,
              width: 200,
              testData: ''
            },
          }
        ]),
        new hiprint.PrintElementTypeGroup("表格", ops.tableobj),
        new hiprint.PrintElementTypeGroup("辅助", [
          {
            tid: 'aProviderModule.hline',
            text: '横线',
            type: 'hline'
          },
          {
            tid: 'aProviderModule.vline',
            text: '竖线',
            type: 'vline'
          },
          {
            tid: 'aProviderModule.rect',
            text: '矩形',
            type: 'rect'
          },
          {
            tid: 'aProviderModule.oval',
            text: '椭圆',
            type: 'oval'
          },
          {
            tid: 'aProviderModule.arrow',
            text: '箭头',
            data: '设置箭头',
            type: 'image',
            options: {
              width: 45,
              height: 45
            }
          },
        ])
      ]
    );
  };
  return {
    addElementTypes: addElementTypes
  };
};

// type: 1供货商 2经销商
export default [{
  name: 'A设计',
  value: 'aProviderModule',
  type: 1,
  f: aProvider
}]
